import PollFooter from "./PollFooter";

export default PollFooter;
